export enum TrackObjectType {
    Product = 0
}